export default "__VITE_ASSET__f334aca1__"